import styled from '@emotion/styled/macro';

export const ButtonLink = styled.a`
    width: 100%;
`;

export const CountDownTimerWrapper = styled.div`
    width: 100%;
    margin-bottom: ${props => props.theme.spacing.xlarge};
`;

export const ContentWrapper = styled.div`
    width: 100%;
    text-align: center;
    padding: 0 ${props => props.theme.spacing.large} 0
        ${props => props.theme.spacing.large};
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    @media (min-width: 1024px) {
        padding: 0;
    }
`;

export const BetPromoWrapper = styled.div`
    width: 100%;
    margin: ${props => props.theme.spacing.large} 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Promos = styled.p`
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
`;

export const PlayItv7Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${props => props.theme.spacing.large} 0;
`;

export const UpComingRoundsWrapper = styled.div`
    width: 100%;
    margin: ${props => props.theme.spacing.large} 0;
`;

export const ShareWrapper = styled.div`
    width: 100%;
    margin-top: ${props => props.theme.spacing.large};
    display: flex;
    justify-content: center;
    align-items: center;
`;
